import * as React from 'react'
import {Hub} from 'yougile-model'
import {TaskDescriptionLayout} from './task-description-layout'
import {
  TaskDescriptionContext,
  TaskDescriptionStore
} from './task-description-store'

type Props = {
  hub?: Hub
  store: TaskDescriptionStore
}

export const TaskDescription = ({hub, store}: Props) => {
  return (
    <TaskDescriptionContext.Provider value={store}>
      <TaskDescriptionLayout hub={hub} />
    </TaskDescriptionContext.Provider>
  )
}
